import { googleRef } from '../utils/external-libs/googleMaps';
import { parseGoogleAddress, US_AND_CANADA } from '../utils/googleAutoCompleteHelper';
import { GooglePlacesObject } from '../utils/googlePlacesObject';

export type AutocompletePrediction = google.maps.places.AutocompletePrediction;

const getAutocompleteToken = () => {
  return new googleRef.maps.places.AutocompleteSessionToken();
};

let placesService: google.maps.places.PlacesService | null = null;

let retries = 0;
const MAX_RETRIES = 70;

const placeServiceSafely = () => {
  const { maps } = googleRef;

  if (!placesService && maps) {
    let container = document.getElementById('places-service-container') as HTMLDivElement;
    if (!container) {
      container = document.createElement('div');
      container.id = 'places-service-container';
      container.style.display = 'none';
      document.body.appendChild(container);
    }

    placesService = new maps.places.PlacesService(container);
  } else if (retries < MAX_RETRIES) {
    retries += 1;
    setTimeout(placeServiceSafely, 100);
  }
};

placeServiceSafely();

export const getPredictions = async (query: string): Promise<AutocompletePrediction[]> => {
  const autoCompleteService = new googleRef.maps.places.AutocompleteService();

  const { predictions } = await autoCompleteService.getPlacePredictions({
    input: query,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    language: 'en',
    componentRestrictions: {
      country: US_AND_CANADA,
    },
    sessionToken: getAutocompleteToken(),
    types: ['address'],
  });

  return predictions;
};

export const getPlaceDetails = async (place: AutocompletePrediction): Promise<GooglePlacesObject | null> =>
  new Promise((resolve) => {
    placesService?.getDetails(
      {
        sessionToken: getAutocompleteToken(),
        placeId: place.place_id,
      },
      (placeResult: unknown) => {
        const placeDetails = placeResult ? (parseGoogleAddress(placeResult) as GooglePlacesObject) : null;
        resolve(placeDetails);
      }
    );
  });
